<template>
  <div>
    <div v-if="projectMetrics.length > 0">
      <b-table
        responsive
        class="custom-table action-items"
        :items="projectMetrics"
        :fields="fields"
      >
        <template #cell(name)="data">
          <b-link @click="launchProjectMetric(data.item)">
            {{ data.item.name }}
          </b-link>
        </template>
        <template #cell(status)="data">
          <div class="lvl">
            <span>{{ data.item.status }}</span>
          </div>
        </template>
        <template #cell(daysOpen)="data">
          {{ calcDaysOpen(data) }}
        </template>
        <template #cell(kebab)="data">
          <b-dropdown
            id="dropdown-1"
            class="kebab"
            text="Additional Options"
            variant="tertiary"
            no-caret
            offset="-125"
          >
            <template #button-content>
              <b-icon
                class="icon kebab additional"
                icon="three-dots-vertical"
                font-scale="1"
              ></b-icon
              ><span class="sr-only">Additional Options</span>
            </template>
            <b-dropdown-item
              v-if="data.item.status != 'Closed'"
              @click="closeProjectMetric(data.item)"
            >
              Close
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.status == 'Closed'"
              @click="undoProjectMetric(data.item)"
            >
              Undo
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(action)="data">
          <b-button
            v-if="data.item.status != 'Closed'"
            @click="closeProjectMetric(data.item)"
            class="text-button"
          >
            <font-awesome-icon
              :icon="['fas', 'times']"
              color="#F7685B"
              size="lg"
            />
          </b-button>
          <b-button
            v-if="data.item.status == 'Closed'"
            @click="undoProjectMetric(data.item)"
            class="text-button"
          >
            <font-awesome-icon :icon="['fa', 'undo-alt']" size="lg" />
          </b-button>
        </template>
        <template #cell(comments)="data">
          <span v-if="data.value == ''">--</span>
          <span v-else>{{ data.value.length }}</span>
        </template>
        <template #cell()="data">
          <span v-if="data.value == ''">--</span>
          <span v-else>{{ data.value }}</span>
        </template>
        <template #cell(champion)="data">
          <span v-if="data.item.assignedToUsers.length == 0">--</span>
          <span v-else>{{
            data.item.assignedToUsers.map((u) => u.name).join(", ")
          }}</span>
        </template>
        <template #cell(timeSaved)="data">
          <span
            v-if="data.item.timeSaved"
            cols="2"
            :class="{
              loss: data.item.timeSaved < 0,
              gain: data.item.timeSaved > 0,
            }"
          >
            {{ data.item.timeSaved }}
          </span>
          <span v-else cols="2"> -- </span>
        </template>
        <template #cell(costSaved)="data">
          <span
            v-if="data.item.timeSaved"
            cols="2"
            :class="{
              loss: data.item.costSaved < 0,
              gain: data.item.costSaved > 0,
            }"
          >
            {{ $helpers.formatDollars(data.item.costSaved) }}
          </span>
          <span v-else cols="2"> -- </span>
        </template>
        <!-- <template v-slot:cell(comments)="data">
            {{data.item.comments.length}}
          </template> -->
      </b-table>

      <ViewProjectMetricModal
        ref="view-project-metric-modal"
        :projectMetric="viewingProjectMetric"
        @refresh="refreshProjectMetric(viewingProjectMetricId)"
      ></ViewProjectMetricModal>
       <EditProjectMetricModal
        ref="edit-project-metric-modal"
        :projectId="viewingProjectMetric ? viewingProjectMetric.projectId : ''"
        :projectMetric="viewingProjectMetric"
        :possibleAssignees="projectUsers"
        @submit="refreshProjectMetric(viewingProjectMetricId)">
      </EditProjectMetricModal>
    </div>
    <div v-else>Nothing to report</div>
  </div>
</template>

<script>
import ViewProjectMetricModal from "@/components/modals/ViewProjectMetricModal.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";

export default {
  name: "ProjectMetricEntries",
  props: {
    projectMetrics: { type: Array, default: () => [] },
    fields: { type: Array, required: true },
    parentItem: { type: Object },
    projectUsers: { type: Array, default: () => [] },
  },
  components: {
    ViewProjectMetricModal,
    EditProjectMetricModal
  },
  data() {
    return {
      viewingProjectMetricId: "",
    };
  },
  methods: {
    viewProjectMetric(id) {
      this.viewingProjectMetricId = id;

      this.$nextTick(() => {
        this.$refs["view-project-metric-modal"].show();
      });
    },
    closeProjectMetric(data) {
      this.$emit("closeItem", data);
    },
    undoProjectMetric(data) {
      let parentItem = this.parentItem == {} ? {} : this.parentItem;
      this.$emit("undoItem", data, parentItem);
    },
    launchProjectMetric(item, index, event) {
      this.viewProjectMetric(item.projectMetricId);
    },
    refreshProjectMetric(id) {
      this.$emit("refresh", id);
    },
    openEditModal(id, returnToView) {
      this.viewingProjectMetricId = id;

      this.$nextTick(() => {
        this.$refs["edit-project-metric-modal"].show(returnToView);
      });
    },
    calcDaysOpen(p) {
       let todaysDate = new Date();
      let startDate = new Date(
        p.item.dateCreated != null? p.item.dateCreated : p.item.dateIdentified != null ?p.item.dateIdentified : new Date()
        );
      let closeDate = new Date(
        p.item.dateResolved != null? p.item.dateResolved :  p.item.dateClosed != null ? p.item.dateClosed : new Date()
      );
      if(todaysDate.getTime() <= closeDate.getTime()){
        let todayTimeOpen = closeDate.getTime() - startDate.getTime();
        let todayShownTime = Math.floor(todayTimeOpen / (1000 * 60 * 60 * 24));
        return todayShownTime > 0 ? todayShownTime : 1;
      }else {
        let timeOpen = closeDate.getTime() - startDate.getTime();
        let shownTime = Math.floor(timeOpen / (1000 * 60 * 60 * 24));
        return shownTime > 0 ? shownTime : 1;
      }
     
    },
  },
  computed: {
    viewingProjectMetric() {
      return this.projectMetrics.find(
        (p) => p.projectMetricId === this.viewingProjectMetricId
      );
    },
  },
};
</script>